export const getFarmPath = (farm, route, append) => {
  const clientId = route.params.client_id
  const companyId = route.params.company_id
  const farmId = farm ? farm.id : route.params.farm_id
  const path = clientId
    ? `/app/clients/${clientId}/companies/${companyId}/farms/${farmId}`
    : `/app/companies/${companyId}/farms/${farmId}`
  return append
    ? `${path}/${append}`
    : path
}
